import $ from 'jquery'

class InsuranceApplication
  restyle_form: ->
    if $(".sticky-progress-bar")
      $(".sticky-progress-bar").parent().parent().css('padding-top', '2.3rem')

window.applications = new InsuranceApplication()
